import { render, staticRenderFns } from "./ImportFormSettings.vue?vue&type=template&id=1b3d32d6&scoped=true&"
import script from "./ImportFormSettings.vue?vue&type=script&lang=ts&"
export * from "./ImportFormSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d32d6",
  null
  
)

export default component.exports